import { GridOptions } from 'ag-grid-community'
import { HcError } from '@/common/types/api.def.ts'

type IntegrityCheckError = {
  checkResults: {
    employeeId: string
    displayName: string
    currentCountry: string
    errors: IntegrityCheckErrorItem[]
  }[]
}

type IntegrityCheckErrorItem = {
  employeeId: string
  displayName: string
  currentCountry: string
  sectionName: string
  message: string
}

export const integrityCheckErrorColumns: GridOptions<IntegrityCheckErrorItem>['columnDefs'] = [
  {
    colId: 'employeeId',
    field: 'employeeId',
    headerName: 'Employee ID',
    width: 150,
  },
  {
    colId: 'displayName',
    field: 'displayName',
    headerName: 'Display Name',
    width: 150,
  },
  {
    colId: 'currentCountry',
    field: 'currentCountry',
    headerName: 'Current Country',
    width: 150,
  },
  {
    colId: 'sectionName',
    field: 'sectionName',
    headerName: 'Section Name',
    width: 175,
  },
  {
    colId: 'message',
    field: 'message',
    headerName: 'Message',
    width: 600,
  },
]

export const integrityCheckErrorMapper = (error?: HcError<IntegrityCheckError> | null) => {
  return error?.details?.checkResults.map(x => x.errors.map(({
    sectionName,
    message,
  }) => ({
    employeeId: x.employeeId,
    displayName: x.displayName,
    currentCountry: x.currentCountry,
    sectionName,
    message,
  }) as IntegrityCheckErrorItem)).flat() || []
}